<template>
  <a-timeline class="comment-timeline">
    <div v-for="operation in historyOperationsFilter" :key="operation.createTime">
      <a-timeline-item :class="getItemColor(operation)">
        <!-- 创建时间 -->
        <div class="operation-createTime">
          <span>{{ operation.createTime | dateformat('YYYY-MM-DD') }}</span>
          <span>{{ operation.createTime | dateformat(' HH:mm:ss') }}</span>
        </div>

        <!-- 操作者 -->
        <div class="operation-actionRealname">{{ operation.actionRealname.split(';')[0] }}</div>

        <!-- 操作节点 -->
        <div class="operation-taskName">{{ '＠' + operation.taskName.replaceAll(' ', '') + '' }}</div>

        <!-- 操作详细 -->
        <div class="operation-action" v-if="!onlyComment">
          <span v-if="operation.actionRealname.indexOf(';') < 0">{{ $t(operation.action) }}</span>
          <span v-else>{{ ' 代理' + operation.actionRealname.split(';')[1] + $t(operation.action) }}</span>

          <template v-if="operation.backwardTaskName">
            <span>{{ '至 ' }}</span>
            <span style="letter-spacing: 1px; color: var(--color-grey)">{{ '＠' + operation.backwardTaskName.replaceAll(' ', '') }}</span>
          </template>

          <template v-if="operation.appointTo">
            <span>{{ '给 ' }}</span>
            <span style="color: var(--color-font)">{{ operation.appointTo }}</span>
          </template>
        </div>

        <div class="operation-comment" v-if="operation.comment">{{ operation.comment }}</div>
      </a-timeline-item>
    </div>
  </a-timeline>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'HistoryOperation',
  props: {
    onlyComment: { type: Boolean, default: false },
    processInstanceId: { type: String, default: '' },
  },
  data() {
    return {
      historyOperations: [],
      historyOperationsFilter: [],
    }
  },
  computed: {},
  created() {
    if (this.processInstanceId) {
      this.historyQuery()
    }
  },
  methods: {
    historyQuery() {
      this.historyOperations = []
      getAction('/flow/processInstanceHistory?processInstanceId=' + this.processInstanceId, null)
        .then((res) => {
          if (res.success) {
            this.historyOperations = res.result

            if (this.onlyComment) {
              this.historyOperationsFilter = XEUtils.filter(
                this.historyOperations,
                (r) =>
                  r.comment &&
                  r.comment.replaceAll(' ', '') &&
                  r.comment.replaceAll('　', '') &&
                  r.comment.replaceAll('\n', '')
              )
            } else {
              this.historyOperationsFilter = this.historyOperations
            }

            // 临时保存只保留最新一个
            var lastTemporaryIndex = XEUtils.findLastIndexOf(
              this.historyOperationsFilter,
              (r) => r.action == 'disp.flow.save'
            )

            if (lastTemporaryIndex > 0) {
              this.historyOperationsFilter = XEUtils.slice(this.historyOperationsFilter, lastTemporaryIndex)
            }

            this.$emit('emit', this.historyOperationsFilter, this.historyOperations)
          } else {
            this.$emit('emit', [], [])
          }
        })
        .finally(() => {})
    },
    getItemColor(operation) {
      if (this.onlyComment) {
        return 'operation-primary'
      } else if (operation.action == 'disp.flow.refuse' || operation.action == 'disp.flow.cancel') {
        return 'operation-red'
      } else if (operation.action == 'disp.flow.turnback' || operation.action == 'disp.flow.pullback') {
        return 'operation-orange'
      } else if (operation.action == 'disp.flow.freeze') {
        return 'operation-blue'
      } else if (operation.action == 'disp.flow.keep') {
        return 'operation-cyan'
      } else if (operation.action == 'disp.flow.confirmPass') {
        return 'operation-purple'
      } else {
        return 'operation-green'
      }
    },
  },
}
</script>

<style lang="less" scoped>
.ant-timeline {
  position: relative;
  background: white;
}

/deep/ .ant-timeline-item {
  padding: 0 0 25px;
}

/deep/ .ant-timeline-item-content {
  white-space: normal;
}

.operation-green {
  /deep/ .ant-timeline-item-head {
    color: green !important;
    border-color: green !important;
  }

  .operation-action {
    color: green;
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-green-5), var(--color-green-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-green-6);
  }
}

.operation-purple {
  /deep/ .ant-timeline-item-head {
    color: var(--color-purple) !important;
    border-color: var(--color-purple) !important;
  }

  .operation-action {
    color: var(--color-purple);
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-purple-5), var(--color-purple-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-purple-6);
  }
}

.operation-red {
  /deep/ .ant-timeline-item-head {
    color: var(--color-red) !important;
    border-color: var(--color-red) !important;
  }

  .operation-action {
    color: var(--color-red);
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-red-5), var(--color-red-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-red-6);
  }
}

.operation-blue {
  /deep/ .ant-timeline-item-head {
    color: var(--color-blue) !important;
    border-color: var(--color-blue) !important;
  }

  .operation-action {
    color: var(--color-blue);
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-blue-5), var(--color-blue-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-blue-6);
  }
}

.operation-orange {
  /deep/ .ant-timeline-item-head {
    color: var(--color-orange) !important;
    border-color: var(--color-orange) !important;
  }

  .operation-action {
    color: var(--color-orange);
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-orange-5), var(--color-orange-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-orange-6);
  }
}

.operation-cyan {
  /deep/ .ant-timeline-item-head {
    color: var(--color-cyan) !important;
    border-color: var(--color-cyan) !important;
  }

  .operation-action {
    color: var(--color-cyan);
  }

  .operation-comment {
    background: linear-gradient(0deg, var(--color-cyan-5), var(--color-cyan-6));
  }

  .operation-comment:before {
    border-bottom: 5px solid var(--color-cyan-6);
  }
}

.operation-createTime {
  margin-bottom: 6px;

  span {
    color: var(--color-grey);
    letter-spacing: 1px;
  }

  span:last-child {
    font-size: 12px;
  }
}

.operation-actionRealname {
  display: inline-block;
}

.operation-taskName {
  display: inline-block;
  color: var(--color-grey);
  margin-left: 6px;
  margin-right: 8px;
  letter-spacing: 1px;
}

.operation-action {
  display: inline-block;
  margin-left: 0px;
}

.operation-comment {
  font-size: 13px;
  padding: 5px 8px 5px 10px;
  width: fit-content;
  max-width: 290px;
  background: linear-gradient(0deg, var(--color-primary-5), var(--color-primary-6));
  position: relative;
  color: white;
  white-space: pre-wrap;
  border-radius: 2px;
  //filter: drop-shadow(0px -2px 4px #e3e3e3);
  margin-top: 10px;
  box-shadow: 0px -2px 4px #e3e3e3;
  letter-spacing: 1px;
  min-width: 30px;
}

.operation-comment:before {
  content: '';
  position: absolute;
  top: -5px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-bottom: 5px solid var(--color-primary-6);
  border-right: 4px solid transparent;
  left: 11px;
}
</style>
